module.exports = __webpack_public_path__ + "static/marketing_strategies-ea920914c0e55407286023a4f38433fe.png";